module.exports = __webpack_public_path__ + "media/hind/Hind-Medium-cb6e25a8.woff";